import React, { useState, useEffect } from "react";
import { Edit, Trash2, Plus, RotateCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "./HouseType.css";

const url = process.env.REACT_APP_BACKEND_URL;

const HouseTypeList = () => {
  const [houseTypes, setHouseTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInactive, setShowInactive] = useState(false);
  const navigate = useNavigate();

  const fetchHouseTypes = async () => {
    try {
      setLoading(true);
      const endpoint = showInactive ? `${url}/api/housetype/all` : `${url}/api/housetype`;
      const res = await axios.get(endpoint);
      setHouseTypes(res.data.data || []);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to fetch house types");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHouseTypes();
  }, [showInactive]);

  const handleSoftDelete = async (id) => {
    if (window.confirm("Are you sure you want to deactivate this house type?")) {
      try {
        const res = await axios.delete(`${url}/api/housetype/${id}`);
        toast.success(res.data.message || "House type deactivated successfully");
        fetchHouseTypes();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to deactivate house type");
      }
    }
  };

  const handleRestore = async (id) => {
    if (window.confirm("Are you sure you want to activate this house type?")) {
      try {
        const res = await axios.put(`${url}/api/housetype/${id}/restore`);
        toast.success(res.data.message || "House type activated successfully");
        fetchHouseTypes();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to activate house type");
      }
    }
  };

  if (loading) return <div className="loading">Loading house types...</div>;

  return (
    <div className="district-container">
      <div className="header">
        <h2>House Types List</h2>
        <div className="header-actions">
          <button
            onClick={() => setShowInactive(!showInactive)}
            className={`toggle-button ${showInactive ? 'active' : ''}`}
          >
            {showInactive ? 'Showing All' : 'Show Active Only'}
          </button>
          <button
            onClick={() => navigate("/AddHouseType")}
            className="add-button"
          >
            <Plus size={16} /> Add House Type
          </button>
        </div>
      </div>

      <div className="district-list">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th style={{ textAlign: "center", width: "150px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {houseTypes.length === 0 ? (
              <tr>
                <td colSpan="3" className="no-data">
                  No house types found
                </td>
              </tr>
            ) : (
              houseTypes.map((houseType) => (
                <tr key={houseType._id} className={houseType.status === 'inactive' ? 'inactive-row' : ''}>
                  <td>{houseType.name}</td>
                  <td>
                    <span className={`status-badge ${houseType.status}`}>
                      {houseType.status === 'active' ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>
                    <div className="actions">
                      {houseType.status === 'active' ? (
                        <>
                          <button
                            onClick={() => navigate(`/housetype/edit/${houseType._id}`)}
                            className="edit"
                            title="Edit"
                          >
                            <Edit size={16} />
                          </button>
                          <button
                            onClick={() => handleSoftDelete(houseType._id)}
                            className="delete"
                            title="Deactivate"
                          >
                            <Trash2 size={16} />
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={() => handleRestore(houseType._id)}
                          className="restore-btn"
                          title="Activate"
                        >
                          <RotateCcw size={16} /> Activate
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HouseTypeList;